import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';

export const retrievePaymentGateways = createAsyncThunk(
	'payment-gateway/retrievePaymentGateways',
	async (params: any) => {
		const res = await baseuri.get('/admin/payment-gateways', {
			params: { ...params },
		});
		console.log('payment gateways', res.data.data);
		return res.data.data;
	}
);

export const createPaymentGateway = createAsyncThunk(
	'payment-gateway/createPaymentGateway',
	async (data: any) => {
		const res = await baseuri.post('/admin/payment-gateways', data);
		message.success('Payment gateway created successfully!');
		return res.data.data;
	}
);
export const editPaymentGateway = createAsyncThunk(
	'payment-gateway/editPaymentGateway',
	async ({ id, data }: { id: any; data: any }) => {
		const res = await baseuri.put(`/admin/payment-gateways/${id}`, data);
		message.success(res?.data?.message);
		return res.data.data;
	}
);
export const deletePaymentGateway = createAsyncThunk(
	'payment-gateway/deletePaymentGateway',
	async (id: any) => {
		const res = await baseuri.delete(`/admin/payment-gateways/${id}`);
		message.success(res?.data?.message);
		return res.data.data;
	}
);

export const verifyAccountName = createAsyncThunk(
	'payment-gateway/verifyAccountName',
	async (data: any) => {
		const res = await baseuri.post('/admin/wallet/name-enquiry', data);
		message.success('Account name  verified successfully!');
		return res.data.data;
	}
);

export const getSafeHavenTransferStatus = createAsyncThunk(
	'payment-gateway/getSafeHavenTransferStatus',
	async (sessionId: string) => {
		const res = await baseuri.get('/admin/safe-haven/transfer-status', {
			params: { sessionId },
		});
		return res.data;
	}
);

export const getVirtualTransaction = createAsyncThunk(
	'payment-gateway/getVirtualTransaction',
	async (virtualAccountId: string) => {
		const res = await baseuri.get(
			`/admin/safe-haven/virtual-transaction/${virtualAccountId}`
		);
		return res.data;
	}
);

export const getVirtualAccountBySafeHavenId = createAsyncThunk(
	'payment-gateway/getVirtualAccountBySafeHavenId',
	async (id: string) => {
		const res = await baseuri.get(`/admin/safe-haven/virtual-account/${id}`);
		return res.data;
	}
);

const paymentGatewayRx = createSlice({
	name: 'paymentGateway',
	initialState: {
		payementgateways: {
			itemsList: [],
			paginator: {
				itemCount: 0,
				currentPage: 1,
				perPage: 20,
				pageCount: 0,
			},
		},
		verifyAccount: {},
		safeHavenResult: null,
		virtualTransactionResult: null,
		virtualAccountResult: null,
	},
	reducers: {
		clearSafeHavenResult: (state) => {
			state.safeHavenResult = null;
		},
		clearVirtualTransactionResult: (state) => {
			state.virtualTransactionResult = null;
		},
		clearVirtualAccountResult: (state) => {
			state.virtualAccountResult = null;
		},
	},
	extraReducers: (builder) =>
		builder
			.addCase(retrievePaymentGateways.fulfilled, (store, action) => {
				const state = store;
				state.payementgateways = action.payload;
			})
			.addCase(verifyAccountName.fulfilled, (store, action) => {
				const state = store;
				state.verifyAccount = action.payload;
			})
			.addCase(getSafeHavenTransferStatus.fulfilled, (store, action) => {
				const state = store;
				state.safeHavenResult = action.payload;
			})
			.addCase(getVirtualTransaction.fulfilled, (store, action) => {
				const state = store;
				state.virtualTransactionResult = action.payload;
			})
			.addCase(getVirtualAccountBySafeHavenId.fulfilled, (store, action) => {
				const state = store;
				state.virtualAccountResult = action.payload;
			}),
});

export const {
	clearSafeHavenResult,
	clearVirtualTransactionResult,
	clearVirtualAccountResult,
} = paymentGatewayRx.actions;

export default paymentGatewayRx.reducer;
